import './styles.scss';

export type headTableColumnType = {
  text: string;
  id: string;
  type: 'buy' | 'sell' | 'none';
};

interface IHeadTableProps {
  columns: headTableColumnType[];
  renderColumn(id: string): JSX.Element | string;
}

const HeadTable = ({ columns, renderColumn }: IHeadTableProps) => {
  return (
    <div className='modal_head_table'>
      <div className='modal_head_table__header'>
        {columns.map(({ text, type }, index) => {
          if (type === 'buy') {
            return (
              <div key={index} className='modal_head_table__header__item'>
                {text}
                <span style={{ color: 'var(--green-600)' }}>BUY</span>s
              </div>
            );
          }
          if (type === 'sell') {
            return (
              <div
                key={index}
                className='modal_head_table__header__item modal_head_table__priceSellUSD'
              >
                {text}
                <span style={{ color: 'var(--red-600)' }}>SELL</span>s
              </div>
            );
          }
          return (
            <div key={index} className='modal_head_table__header__item'>
              {text}
            </div>
          );
        })}
      </div>

      <div className='modal_head_table__body'>
        {columns.map(({ id }) => (
          <div key={id} className='modal_head_table__body__item'>
            {renderColumn(id)}
          </div>
        ))}
      </div>
    </div>
  );
};

export default HeadTable;
